var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticStyle:{"height":"100%"},attrs:{"background-color":"#ebeef5"},on:{"select":_vm.jump}},_vm._l((_vm.menus),function(menu,key){return _c('menu-item',{key:key,attrs:{"url":menu.url,"icon":menu.icon,"name":menu.name,"children":menu.children}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-616c4525","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/LayoutAside.vue
// module id = null
// module chunks = 